import { PartnerSlug } from "types/general";
import { ApiUserProfile } from "utils/api/user";

export const getHelpMessage = (userProfile: ApiUserProfile) => {
  if (userProfile?.partnerSlug === PartnerSlug.msufcu) {
    return "In order to get free tax filing and access your refund early if you are eligible, you must elect to deposit your refund into the account below. You'll be asked to confirm this again before submitting your return.";
  }

  if (userProfile?.incomeTaxRefundAdvanceAllowed) {
    return "In order to get a credit for tax filing and access your refund early if you are eligible, you must elect to deposit your refund into the account below. You'll be asked to confirm this again before submitting your return.";
  }

  return "Your primary checking account details are below. You'll be asked to enter them if you decide to direct deposit your refund.";
};

export const getSubheading = (userProfile: ApiUserProfile) => {
  if (userProfile?.incomeTaxRefundAdvanceAllowed) return null;

  return "Once you've submitted your tax return, you'll have an opportunity to apply for the Reset card and earn a credit for your tax filing fee.";
};
